import { useContext } from 'react'
import styled from 'styled-components'
import CreationToolUploadField from '../../../types/upload-field'
import UsernameField from '../../form-fields/upload/username'
import { CreationToolUploadContext } from '../manager'

const Username = styled(UsernameField)`
    grid-column: span 4;
`

type Props = {
    className?: string
    field: CreationToolUploadField
}

const CreationUploadUsernameField = ({ className, field }: Props) => {
    const { username, setUsername } = useContext(CreationToolUploadContext)

    return (
        <Username
            {...{
                className,
                field,
                username,
                showInstructions: true,
                onChange: setUsername,
            }}
        />
    )
}

export default CreationUploadUsernameField
